import { inject, Service } from '@angular/core';
import { Store } from '@ngrx/store';
import { cartonsActions } from '../actions/cartons.actions';
import { CartonsStatus } from '../models';
import { selectBoxes, selectHasMore, selectLoaded, selectLoading, selectPage, selectStatus } from '../selectors/cartons.selector';

@Service()
export class CartonsFacade {
    private readonly store = inject(Store);

    readonly boxes = this.store.selectSignal(selectBoxes);
    readonly status = this.store.selectSignal(selectStatus);
    readonly page = this.store.selectSignal(selectPage);
    readonly hasMore = this.store.selectSignal(selectHasMore);
    readonly loaded = this.store.selectSignal(selectLoaded);
    readonly loading = this.store.selectSignal(selectLoading);

    loadCartons(status: CartonsStatus): void {
        this.store.dispatch(cartonsActions.loadCartons({ status, page: 1 }));
    }

    loadMoreCartons(): void {
        this.store.dispatch(cartonsActions.loadCartons({ status: this.status(), page: this.page() + 1 }));
    }

    clear(): void {
        this.store.dispatch(cartonsActions.clear());
    }
}
